import React, { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle, } from 'react-native-reanimated';
import { INVISIBLE_TEXT_COLOR, NavigationHeader, rem } from 'design-system';
import CollapsableParallax from 'design-system/CollapsableParallax';
import SelectorControllableReanimated from 'design-system/SelectorControllableReanimated';
import { styles as textStyles } from 'design-system/Text';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { tierThemes } from '../benefits';
import { getThemeGradient } from '../colors';
const COLLAPSIBLE_PARALLAX_HEIGHT = rem(56);
const PremiumScreenHeader = ({ currentTierDerivedValue, activeTier, scrollY, scrollX, screenWidth, tiersInOrder, rightContent, title, isInTab, onSelectView, showSelector = true, }) => {
    const colors = useColors();
    const yourPlanStyle = useAnimatedStyle(() => ({
        color: currentTierDerivedValue.value === activeTier
            ? colors.text.primary
            : INVISIBLE_TEXT_COLOR,
    }), [currentTierDerivedValue, activeTier, colors]);
    const upgradeStyle = useAnimatedStyle(() => ({
        color: currentTierDerivedValue.value !== activeTier
            ? colors.text.primary
            : INVISIBLE_TEXT_COLOR,
    }), [currentTierDerivedValue, activeTier, colors]);
    const tierSections = useMemo(() => tiersInOrder.map((tier) => ({
        id: tier,
        color: getThemeGradient(tier, colors)?.colors?.[0],
        text: tierThemes[tier].shortName,
        width: tierThemes[tier].width,
        selectedTextColor: colors.text.onPrimary,
        unSelectedTextColor: colors.text.secondary,
    })), [colors, tiersInOrder]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isInTab);
    return (<NavigationHeader renderTitle={(titleStyle) => (<View style={styles.headerTitleContainer}>
          <Animated.Text style={[titleStyle, styles.title, yourPlanStyle]}>
            Your plan
          </Animated.Text>
          <Animated.Text style={[titleStyle, styles.title, upgradeStyle]}>
            {title}
          </Animated.Text>
        </View>)} rightContent={rightContent} scrollY={scrollY} hideTitleOnScroll withFrame isInTab={isInTab} absolute>
      <CollapsableParallax scrollY={scrollY} style={styles.titleContainer} height={COLLAPSIBLE_PARALLAX_HEIGHT}>
        <View style={[styles.titleContainer]}>
          <Animated.Text style={[
            styles.title,
            textStyles.Text_32,
            paddingHorizontalStyle,
            yourPlanStyle,
        ]}>
            {showSelector ? 'Your plan' : 'Emma Ultimate'}
          </Animated.Text>
          <Animated.Text style={[
            styles.title,
            textStyles.Text_32,
            paddingHorizontalStyle,
            upgradeStyle,
        ]}>
            {title}
          </Animated.Text>
        </View>
      </CollapsableParallax>
      {showSelector ? (<SelectorControllableReanimated screenWidth={screenWidth} style={styles.selectorControllable} selectorStyle={styles.selectorStyle} itemStyle={styles.itemStyle} itemContainerStyle={styles.itemContainerStyle} sections={tierSections} setSelection={onSelectView} scrollX={scrollX}/>) : null}
    </NavigationHeader>);
};
const styles = StyleSheet.create({
    title: {
        position: 'absolute',
    },
    headerTitleContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectorStyle: {
        borderRadius: rem(8),
    },
    itemStyle: {
        paddingVertical: rem(4),
        borderRadius: rem(8),
    },
    itemContainerStyle: {
        justifyContent: 'flex-start',
    },
    titleContainer: {
        paddingHorizontal: rem(16),
    },
    selectorControllable: {
        marginTop: rem(8),
        marginBottom: rem(16),
        marginHorizontal: rem(16),
    },
});
export default memo(PremiumScreenHeader);
